// 此文件由 scripts/generate-role.ts 自动生成
// 请勿手动修改，修改请编辑 角色权限表.xlsx 后重新生成

export type RoleType = {
  value: string;
  label: string;
};

export enum Role {
  CATL = 'CATL',
  PRODUCER = 'PRODUCER',
  OPERATOR = 'OPERATOR',
  MAINTAINER = 'MAINTAINER',
  TERMINAL_ADMIN = 'TERMINAL_ADMIN',
  STATION_ADMIN = 'STATION_ADMIN',
  STATION_MAINTAINER = 'STATION_MAINTAINER',
}

export const StaticRoles: RoleType[] = [
  { value: 'CATL', label: 'CATL' },
  { value: 'PRODUCER', label: '车企' },
  { value: 'OPERATOR', label: '营运' },
  { value: 'MAINTAINER', label: '机务' },
  { value: 'TERMINAL_ADMIN', label: '终端管理员' },
  { value: 'STATION_ADMIN', label: '充电站管理员' },
];

export const DynamicRoles: RoleType[] = [{ value: 'STATION_MAINTAINER', label: '充电站运营人员' }];

export const RoleToPermissions: Record<string, string[]> = {
  [Role.CATL]: [
    'overview:view',
    'monitor:vehicle:view',
    'data:alarm:view',
    'data:batteryFault:view',
    'data:insulationFault:view',
    'data:tierFault:view',
    'data:chargingOrder:view',
    'ticket:view',
    'report:alarm:view',
    'report:ticket:view',
    'report:batteryFault:view',
    'report:insulationFault:view',
    'report:tierFault:view',
    'report:charging:view',
    'report:tripEnergy:view',
    'report:vehicleStatus:view',
    'analysis:alarm:view',
    'analysis:chargingHabit:view',
    'vehicle:detail:view',
    'vehicleMonitor:dataDetails:view',
    'vehicleMonitor:tboxAnalysis:view',
    'settings:vehicle:view',
  ],
  [Role.PRODUCER]: [
    'overview:view',
    'monitor:vehicle:view',
    'data:alarm:view',
    'data:batteryFault:view',
    'data:insulationFault:view',
    'data:tierFault:view',
    'ticket:view',
    'report:alarm:view',
    'report:ticket:view',
    'report:batteryFault:view',
    'report:insulationFault:view',
    'report:tierFault:view',
    'report:charging:view',
    'report:tripEnergy:view',
    'report:vehicleStatus:view',
    'analysis:alarm:view',
    'vehicle:detail:view',
    'vehicleMonitor:dataDetails:view',
    'vehicleMonitor:tboxAnalysis:view',
    'settings:vehicle:view',
  ],
  [Role.OPERATOR]: [
    'overview:view',
    'monitor:vehicle:view',
    'monitor:station:view',
    'data:alarm:view',
    'data:batteryFault:view',
    'data:insulationFault:view',
    'data:tierFault:view',
    'data:chargingOrder:view',
    'ticket:write:vehicle',
    'ticket:view',
    'report:alarm:view',
    'report:ticket:view',
    'report:batteryFault:view',
    'report:insulationFault:view',
    'report:tierFault:view',
    'report:charging:view',
    'report:tripEnergy:view',
    'report:vehicleStatus:view',
    'analysis:alarm:view',
    'analysis:chargingHabit:view',
    'analysis:chargingAlarm:view',
    'vehicle:detail:view',
    'vehicle:detail:edit',
    'settings:vehicle:view',
    'settings:vehicle:write',
    'settings:vehicle:import',
    'settings:vehicle:export',
    'settings:orgStructure:view',
    'vehicleMonitor:terminal:view',
    'vehicleMonitor:dataDetails:view',
  ],
  [Role.MAINTAINER]: [
    'overview:view',
    'monitor:vehicle:view',
    'monitor:station:view',
    'data:alarm:view',
    'data:alarm:write',
    'data:batteryFault:view',
    'data:insulationFault:view',
    'data:tierFault:view',
    'data:chargingOrder:view',
    'data:chargingAlarm:view',
    'ticket:write:vehicle',
    'ticket:write:station',
    'ticket:view',
    'station:view',
    'station:edit',
    'station:chargingOrder:edit',
    'station:maintain',
    'report:alarm:view',
    'report:ticket:view',
    'report:batteryFault:view',
    'report:insulationFault:view',
    'report:tierFault:view',
    'report:charging:view',
    'report:tripEnergy:view',
    'report:vehicleStatus:view',
    'analysis:alarm:view',
    'analysis:chargingHabit:view',
    'analysis:chargingAlarm:view',
    'vehicle:detail:view',
    'vehicle:detail:edit',
    'vehicleMonitor:terminal:view',
    'vehicleMonitor:dataDetails:view',
    'vehicleMonitor:tboxAnalysis:view',
    'settings:vehicle:view',
    'settings:vehicle:write',
    'settings:vehicle:import',
    'settings:vehicle:export',
    'settings:orgStructure:view',
    'settings:orgStructure:write',
    'settings:user:write',
    'settings:serviceProvider:view',
    'settings:serviceProvider:write',
    'settings:operationLog:view',
  ],
  [Role.TERMINAL_ADMIN]: [
    'overview:view',
    'monitor:vehicle:view',
    'vehicle:detail:view',
    'vehicleMonitor:terminal:view',
    'vehicleMonitor:dataDetails:view',
    'vehicleMonitor:tboxAnalysis:view',
  ],
  [Role.STATION_ADMIN]: [
    'overview:view',
    'monitor:station:view',
    'data:chargingOrder:view',
    'data:chargingAlarm:view',
    'ticket:write:station',
    'station:view',
    'station:edit',
    'station:chargingOrder:edit',
    'station:maintain',
    'settings:serviceProvider:view',
    'settings:serviceProvider:write',
  ],
  [Role.STATION_MAINTAINER]: [
    'overview:view',
    'ticket:write:station',
    'station:view',
    'station:chargingOrder:edit',
    'station:maintain',
  ],
};

export const P = {
  overview: {
    view: 'overview:view',
  },
  monitor: {
    vehicle: {
      view: 'monitor:vehicle:view',
    },
    station: {
      view: 'monitor:station:view',
    },
  },
  data: {
    alarm: {
      view: 'data:alarm:view',
      write: 'data:alarm:write',
    },
    batteryFault: {
      view: 'data:batteryFault:view',
    },
    insulationFault: {
      view: 'data:insulationFault:view',
    },
    tierFault: {
      view: 'data:tierFault:view',
    },
    chargingOrder: {
      view: 'data:chargingOrder:view',
    },
    chargingAlarm: {
      view: 'data:chargingAlarm:view',
    },
  },
  ticket: {
    view: 'ticket:view',
    write: {
      vehicle: 'ticket:write:vehicle',
      station: 'ticket:write:station',
    },
  },
  report: {
    alarm: {
      view: 'report:alarm:view',
    },
    ticket: {
      view: 'report:ticket:view',
    },
    batteryFault: {
      view: 'report:batteryFault:view',
    },
    insulationFault: {
      view: 'report:insulationFault:view',
    },
    tierFault: {
      view: 'report:tierFault:view',
    },
    charging: {
      view: 'report:charging:view',
    },
    tripEnergy: {
      view: 'report:tripEnergy:view',
    },
    vehicleStatus: {
      view: 'report:vehicleStatus:view',
    },
  },
  analysis: {
    alarm: {
      view: 'analysis:alarm:view',
    },
    chargingHabit: {
      view: 'analysis:chargingHabit:view',
    },
    chargingAlarm: {
      view: 'analysis:chargingAlarm:view',
    },
  },
  vehicle: {
    detail: {
      view: 'vehicle:detail:view',
      edit: 'vehicle:detail:edit',
    },
  },
  vehicleMonitor: {
    dataDetails: {
      view: 'vehicleMonitor:dataDetails:view',
    },
    tboxAnalysis: {
      view: 'vehicleMonitor:tboxAnalysis:view',
    },
    terminal: {
      view: 'vehicleMonitor:terminal:view',
    },
  },
  settings: {
    vehicle: {
      view: 'settings:vehicle:view',
      write: 'settings:vehicle:write',
      import: 'settings:vehicle:import',
      export: 'settings:vehicle:export',
    },
    orgStructure: {
      view: 'settings:orgStructure:view',
      write: 'settings:orgStructure:write',
    },
    user: {
      write: 'settings:user:write',
    },
    serviceProvider: {
      view: 'settings:serviceProvider:view',
      write: 'settings:serviceProvider:write',
    },
    operationLog: {
      view: 'settings:operationLog:view',
    },
  },
  station: {
    view: 'station:view',
    edit: 'station:edit',
    chargingOrder: {
      edit: 'station:chargingOrder:edit',
    },
    maintain: 'station:maintain',
  },
};
